import React from "react";
import { ShoppingListRequirementDto } from "../../api";
import { Purchase } from "../../data/purchase";
import { formatGermanDateShort } from "../../utils/dateUtils";
import {
  formatPurchaseDescription,
  getDefaultPurchaseUnit,
} from "../../utils/purchaseUtils";
import { NumberInput } from "../ui/Input";
import { Plan2PlateIcon } from "../Plan2PlateIcon";
import { Glyph } from "../SmallIconButton";

interface RequirementRowProps {
  requirement: ShoppingListRequirementDto;
  purchase: Purchase;
  missingInShops: boolean;
  onAmountChange: (amount: number) => void;
  onDelete: () => void;
  onAvailabilityOpen: () => void;
}

export const RequirementRow = ({
  requirement,
  purchase,
  missingInShops,
  onAmountChange,
  onDelete,
  onAvailabilityOpen,
}: RequirementRowProps) => {
  const defaultUnit = getDefaultPurchaseUnit(purchase);

  return (
    <div className="flex items-start gap-3 py-3 border-b border-line last:border-0">
      <div className="flex-1 min-w-0">
        <div className="flex justify-between items-center gap-1">
          <span className="font-semibold text-sm text-ink truncate">
            {formatPurchaseDescription(purchase)}
          </span>
          {requirement.amount == 0 ? (
            <span className="font-bold text-xl text-protein">·</span>
          ) : missingInShops ? (
            <span className="font-bold text-xl text-gold">·</span>
          ) : undefined}
        </div>
        {requirement.mealDetails.map((detail) => (
          <p key={detail.mealDate} className="text-2xs text-ink-muted">
            {formatGermanDateShort(detail.mealDate)}&ensp;
            {detail.amount}
            {defaultUnit.description}
          </p>
        ))}
      </div>

      <div className="flex items-center gap-1 shrink-0">
        <div className="w-24">
          <NumberInput
            value={requirement.amount}
            onValueChange={(v) => onAmountChange(v ?? 0)}
            unit={defaultUnit.description}
          />
        </div>
        <button
          type="button"
          onClick={onAvailabilityOpen}
          className="text-ink-muted hover:text-teal transition"
          title="Verfügbarkeit anpassen"
        >
          <Glyph icon={"shopCart"} size={28} />
        </button>
        <button
          type="button"
          onClick={onDelete}
          className="text-ink-muted hover:text-protein transition"
          title="Entfernen"
        >
          <Glyph icon={"delete"} size={28} />
        </button>
      </div>
    </div>
  );
};
